import { Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { DRAWER_FORM_GRID_SPACING } from "../../../../lib/ui/dialogFormLayout";

const CreateAnomalyGuideDialogBody = () => {
  const { t } = useTranslation();

  return (
    <DrawerForm>
      <DrawerFormSection title={t("anomalyGuides.form.category")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={6}>
            <TextField
              autoFocus
              required
              fullWidth
              id="category"
              name="category"
              label={t("anomalyGuides.form.category")}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              id="subCategory"
              name="subCategory"
              label={t("anomalyGuides.form.subcategory")}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="classificationGuidance"
              name="classificationGuidance"
              label={t("anomalyGuides.form.classificationGuidance")}
              variant="outlined"
              size="small"
              multiline
              rows={6}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default CreateAnomalyGuideDialogBody;
